import { Outlet } from 'react-router-dom'
import React from 'react'
import Error401 from '../ErrorPages/Error401'


const PrivateRoutes = () => {
  const user = JSON.parse(localStorage.getItem('user'))
  return (
    user?.accessToken ? <Outlet/> : <Error401/>
  )
}

export default PrivateRoutes